import o from"./index.module.scss.js";const s=o;export{s as InputTheme};
//# sourceMappingURL=index.js.map
